
import React from 'react'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Components/Price/Price.scss'
import { numberFormatter } from 'Utils/helpers/formatters'
import { getCurrentPrice } from 'Utils/helpers/productAttributeHelper'
import { ProductListData } from 'Utils/api/gql/types'

export type ProductPriceData = Pick<ProductListData, 'price' | 'price_per_unit' | 'price_unit' | 'special_price' | 'special_from_date' | 'special_to_date' | 'vat' | 'default_quantity_name' | 'personal_discount_price'>

type PropType = {
  className?: string
  product: ProductPriceData
  qty: number
}

const DisplayPrice: React.SFC<PropType> = (props) => {
  const {
    children,
    className,
    product,
    ...otherProps
  } = props
  const classNames = `${cl.priceContainer} ${className || ''}`

  const price = getCurrentPrice(product) * props.qty
  const unitPrice = getCurrentPrice(product)

  return (
    <div className={classNames} {...otherProps}>
      <div className={cn(cg.gridX, cg.alignMiddle)}>
        <div className={cn(cg.cell, cl.priceContent)}>
          <span className={cl.price}>
            {numberFormatter(price)} Ft
          </span>
        </div>

        {unitPrice && <span className={cn(cg.cell, cl.priceInfo)}>{`${numberFormatter(unitPrice)} Ft / ${product.default_quantity_name}`}</span>}
      </div>
    </div>
  )
}

export default DisplayPrice
